<template>
  <div>
    <b-overlay :show="upload" no-wrap fixed>
      <template v-slot:overlay>
        <div class="text-center p-4 bg-primary text-light rounded">
          <b-icon icon="cloud-upload" font-scale="4"></b-icon>
          <div class="mb-3">
            Uploading {{ files[index].name }}... ({{ index + 1 }}/{{
              files.length
            }})
          </div>
          <b-progress
            min="0"
            max="100"
            :value="progress"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
          <button
            class="btn btn-outline-light mt-3"
            @click="
              upload = false;
              cancel = true;
            "
          >
            Cancel
          </button>
        </div>
      </template>
    </b-overlay>
    <button class="btn btn-outline-dark" @click="showUpload = !showUpload">
      Upload Files to Student Gallery
    </button>
    <br />
    <div v-if="showUpload">
      <br />
      <v-text-field
        label="Email"
        v-model.trim="email"
        :error-messages="emailErr"
      ></v-text-field>
      <b-form-group label="Select file type:">
        <b-form-radio value="photos" v-model="fileType">Image</b-form-radio>
        <b-form-radio value="videos" v-model="fileType">Video</b-form-radio>
        <b-form-radio value="other" v-model="fileType">Other</b-form-radio>
      </b-form-group>
      <b-form-group label="Select file(s):">
        <b-form-file
          v-model="files"
          :disabled="!fileType"
          placeholder="Choose files"
          multiple
          no-drop
          :file-name-formatter="formatNames"
          :accept="acceptType"
        ></b-form-file>
      </b-form-group>
      <button
        :disabled="!fileType || !checkComplete || !files.length"
        class="btn btn-sm btn-outline-success"
        @click="uploadF"
      >
        Upload
      </button>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";
const fb = require("../../firebaseConfig");
export default {
  data() {
    return {
      index: 0,
      upload: false,
      progress: 0,
      success: 0,
      showUpload: false,
      email: "",
      emailErr: "",
      checkComplete: false,
      files: [],
      fileType: null,
    };
  },
  watch: {
    email: function (newVal, oldVal) {
      this.checkComplete = false;
      this.emailErr = "";
      if (!newVal) {
        return;
      }
      this.debouncedChange();
    },
    fileType: function (newVal, oldVal) {
      this.files = [];
    },
  },
  computed: {
    acceptType() {
      if (this.fileType == "photos") {
        return "image/*";
      } else if (this.fileType == "videos") {
        return "video/*";
      } else {
        return null;
      }
    },
  },
  created() {
    this.debouncedChange = debounce(this.change, 2000);
  },
  methods: {
    change() {
      if (!this.email) {
        return;
      }
      fb.db
        .collection("users")
        .where("type", "==", "student")
        .where("email", "==", this.email.toLowerCase())
        .get()
        .then((qs) => {
          if (qs.empty) {
            this.emailErr = "No student found";
          } else {
            this.checkComplete = true;
          }
        });
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    uploadF() {
      const vue = this;
      let filesize = 0;
      vue.files.forEach((file) => {
        filesize += file.size;
      });
      if (filesize > 350 * 1024 * 1024) {
        this.$emit("toast", "err", "Overall file size must be less than 100MB");
        return;
      }
      vue.upload = true;
      for (let i = 0, p = Promise.resolve(); i < vue.files.length; i++) {
        p = p.then(
          (_) =>
            new Promise((resolve) => {
              vue.index = i;
              const item = vue.files[i];
              const refPath = `${this.fileType}/${vue.email.toLowerCase()}/${
                item.name
              }`;

              const ref = fb.storageRef.child(refPath);

              var uploadTask = ref.put(item);

              uploadTask.on(
                "state_changed",
                function (snapshot) {
                  if (vue.cancel) {
                    uploadTask.cancel();
                  }
                  // Observe state change events such as progress, pause, and resume
                  // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                  const progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                  vue.progress = progress.toFixed(0);

                  switch (snapshot.state) {
                    case fb.firebase.storage.TaskState.PAUSED: // or 'paused'
                      console.log("Upload is paused");
                      break;
                  }
                },
                function (error) {
                  // Handle unsuccessful uploads
                  console.log("Upload unsuccessful: ", error);
                  vue.progress = 0;
                  if (i == vue.files.length - 1) {
                    vue.complete();
                  }
                  resolve();
                },
                function () {
                  // Handle successful uploads on complete
                  // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                  uploadTask.snapshot.ref
                    .getDownloadURL()
                    .then(function (downloadURL) {
                      console.log("File available at", downloadURL);
                      vue.success += 1;
                      vue.progress = 0;
                      if (i == vue.files.length - 1) {
                        vue.complete();
                      }
                      resolve();
                    });
                }
              );
            })
        );
      }
    },
    complete() {
      this.upload = false;
      this.cancel = false;
      const vue = this;
      if (vue.success == vue.files.length) {
        vue.$emit("toast", "suc", "File(s) uploaded successfully");
      } else if (vue.success > 0) {
        vue.$emit(
          "toast",
          "war",
          vue.success + "/" + vue.files.length + " files uploaded successfully"
        );
      } else {
        vue.$emit("toast", "err", "Upload failed");
      }
      vue.success = 0;
      vue.files = [];
      vue.fileType = null;
      vue.email = "";
      vue.showUpload = false;
    },
  },
};
</script>